// Dependencies of brooklyn.js
import 'lodash';
import 'scrolltofixed';

// Theme Main JS
import '../vendor/brooklyn';

// Styles
import '../../styles/style.scss';

// Scripts
import '../vendor/slick/slick.js';
import '../vendor/ProxyLink.js';
import '../vendor/TimedPopup.js';
import '../vendor/parsley.js';
import Tabs from '../components/tabs.js';
import '../components/gsap-collapse.js';
import '../components/knitkit.js';
import '../components/input.js';
import '../sections/announcement-bar.js';
import '../components/header.js';
import '../components/accordion.js';
import '../components/desktop-slider.js';
import '../components/media.js';
import '../components/minicart.js';
import NewsletterForm from '../components/newsletter-form.js';

import '../snippets/product-tile.js';
import '../snippets/wishlist.js';
import '../snippets/geolocation.js';
import '../snippets/collection-filters.js';
import '../snippets/share-buttons.js';
import '../snippets/contact-form.js';
import '../snippets/carousel-banner.js';
import '../snippets/lang-switcher.js';
import '../snippets/country-switcher.js';
import '../sections/newsletter-popup.js';

// import '../blocks/sample-block.js';

import { initMinicart } from '../components/minicart.js';
import { initBackdrop } from '../components/backdrop.js';
import { qtySelectors } from '../components/quantity.js';

$(function () {
  Tabs();
  NewsletterForm();

  if (
    typeof window.Ajaxinate !== 'undefined' &&
    (document.getElementById('AjaxinateContainer') ||
      document.querySelector('.blog__articles--ajaxinate'))
  ) {
    var anchorStart = window.location.href.indexOf('#');
    var itemID =
      anchorStart != -1 ? window.location.href.substr(anchorStart) : '';
    var preLoadingEnded = true; // Flag to check if were loading back pages
    var ajaxPageParamStart = window.location.href.indexOf('?i=');
    var ajaxPageParamEnd =
      anchorStart != -1 ? window.location.href.length - anchorStart : undefined;
    var ajaxPageNumber =
      ajaxPageParamStart != -1
        ? parseInt(
            window.location.href
              .substr(ajaxPageParamStart, ajaxPageParamEnd)
              .replace('?i=', ''),
          )
        : false;

    var preLoadNextPage = function () {
      window.endlessScroll.currentPage++;
      window.endlessScroll.pagesToLoad--;

      window.setTimeout(function () {
        if (window.endlessScroll.nextPageLinkElement) {
          window.endlessScroll.nextPageUrl =
            window.endlessScroll.nextPageLinkElement.getAttribute('href');
          window.endlessScroll.loadMore();
        }
      }, 10); // Please lord of javascript forgive me for this!

      console.log(window.endlessScroll.pagesToLoad);

      if (!window.endlessScroll.pagesToLoad) {
        preLoadingEnded = true;
      }
    };

    if (document.querySelector('.blog')) {
      const ajaxinateContainer = document.querySelector(
        '.blog__articles--ajaxinate',
      );
      const ajaxinatePagination = document.querySelector(
        '.blog__pagination--ajaxinate',
      );
      const elementsCounter = document.querySelector(
        '.blog__footer [data-counter]',
      );
      if (
        ajaxinateContainer &&
        ajaxinatePagination &&
        typeof window.Ajaxinate !== 'undefined'
      ) {
        window.endlessScroll = new Ajaxinate({
          container: '.blog__articles--ajaxinate',
          pagination: '.blog__pagination--ajaxinate',
          method: 'click',
          callback: function (requestURL) {
            window.dAgency.ajaxinateCallBack(
              requestURL,
              '.blog__articles--ajaxinate',
            );
            if (elementsCounter) {
              elementsCounter.innerText =
                ajaxinateContainer.querySelectorAll('.blog__article').length;
            }
          },
        });
      }
    } else {
      window.endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: 'click',
        callback: function (requestURL) {
          window.dAgency.ajaxinateCallBack(requestURL);
        },
      });
    }

    if (typeof window.endlessScroll !== 'undefined') {
      window.endlessScroll.currentPage = 1;
    }

    if (ajaxPageNumber) {
      window.scrollTo({ left: 0, top: 0 });
      preLoadingEnded = false;
      window.endlessScroll.pagesToLoad = ajaxPageNumber - 1;
      preLoadNextPage();
    }
  }

  $('[data-timed-popup]').TimedPopup();

  window.dAgency.ajaxinateCallBack = (
    requestURL,
    ajaxinateSelector = '#AjaxinateContainer',
  ) => {
    var $proxyLinks = $(ajaxinateSelector).find('[data-link-proxy]');

    if ($proxyLinks.length > 1) {
      $proxyLinks.off('click');

      $proxyLinks.ProxyLink({
        excludes: [
          '.slick-dots',
          '.product-tile__variant',
          '.swym-add-to-wishlist-view-product',
        ],
        onBeforeUnload: function ($proxyLink) {
          const itemID = $proxyLink.data('pid');
          const requestedPageNum = requestURL
            .substr(requestURL.indexOf('?page='))
            .replace('?page=', '');

          if (itemID) {
            history.replaceState(
              {},
              'page ' + requestedPageNum,
              '?i=' + requestedPageNum + '#' + itemID,
            );
          } else {
            history.replaceState(
              {},
              'page ' + requestedPageNum,
              '?i=' + requestedPageNum,
            );
          }
        },
      });
    }

    const productsCounter = document.querySelector('[data-current-counter]');
    if (productsCounter) {
      const productsTiles = document.querySelectorAll(
        '#CollectionSection .product-tile__container, .search__products .product-tile__container',
      );
      productsCounter.innerText = productsTiles.length;
    }

    // Init wishlist buttons
    document.dispatchEvent(new CustomEvent('swym:collections-loaded'));

    // Scroll back to latest position
    var requestedPageNum = requestURL
      .substr(requestURL.indexOf('?page='))
      .replace('?page=', '');

    if (preLoadingEnded) {
      window.endlessScroll.currentPage = requestedPageNum;

      if (itemID) {
        history.replaceState(
          {},
          'page ' + requestedPageNum,
          '?i=' + requestedPageNum + itemID,
        );
      } else {
        history.replaceState(
          {},
          'page ' + requestedPageNum,
          '?i=' + requestedPageNum,
        );
      }
    }

    if (!window.endlessScroll.pagesToLoad) {
      const headersHeight = $('.site-header').outerHeight(true);

      if (itemID) {
        var itemTop = $(itemID).offset().top - headersHeight;
        window.scrollTo({ left: 0, top: itemTop, behavior: 'smooth' });
        itemID = '';
      }
    }

    if (window.endlessScroll.pagesToLoad) {
      preLoadNextPage();
    }
  };

  const $orderLists = $('[data-order-list]');
  if ($orderLists.length) {
    $orderLists.each(function () {
      const $list = $(this);
      $list
        .find('[data-order-number]')
        .sort(function (a, b) {
          return +a.dataset.orderNumber - +b.dataset.orderNumber;
        })
        .appendTo($list);
    });
    window.setTimeout(function () {
      $orderLists.attr('data-order-list', 'ready');
    }, 50);
  }

  if (!window.dAgency) window.dAgency = {};

  window.dAgency.proxyLinkSetup = ($context) => {
    if (!$context || !$context.length) $context = $('body');
    const $proxyLinks = $context.find('[data-link-proxy]');

    if ($proxyLinks.length) {
      $proxyLinks.off('click'); // Removing previous proxy link initialization

      $proxyLinks.ProxyLink({
        excludes: [
          '.slick-dots',
          '.product-tile__variant',
          '.swym-add-to-wishlist-view-product',
        ],
      });
    }
  };

  initMinicart();
  initBackdrop();
  qtySelectors();
});




